var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 666,
    viewBox: "0 0 1920 666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;stroke:#707070;}.c{clip-path:url(#c);}.d{clip-path:url(#d);}.e,.f,.g{mix-blend-mode:luminosity;isolation:isolate;}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.062,
    y1: 0.178,
    x2: 1.069,
    y2: 0.66,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f73fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2abbfd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1920,
    height: 666
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2090.464,
    height: 500.183
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.369,
    y1: 0.621,
    x2: -1.221,
    y2: -0.29,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4ddff",
    stopOpacity: 0.322
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.631,
    y1: 0.621,
    x2: 2.221,
    y2: -0.29,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c4ff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4ddff",
    stopOpacity: 0.322
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.631,
    y1: 0.621,
    x2: 2.221,
    y2: -0.29,
    xlinkHref: "#e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1920,
    height: 666,
    transform: "translate(0 80)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-588.962 180.225)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.396)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(866.962 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(119.289 68.617)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-13170.283-9920.341l32.553,62.724h655.594l673.023,90.632,271.7,162.677v-128.753l-854.262-586.764-566.168,414.015-212.439-143.955v129.425Z",
    transform: "translate(13443.983 10319.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-11873.2-9878.711h-472.135l-552.1,8.752h-267l820.469-442.943,455.156,319.918v123.025Z",
    transform: "translate(13844.172 10316.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-11678.12-9925.542l-521.08-5.856-196.152-3.564-627.781,3.564v-3.564l-15.895-7.048,558.986-393.132,591.471,423.6,210.451-138.664v124.669Z",
    transform: "translate(13039.028 10359.231)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-11678.12-9924.621l-521.08-5.856-196.152-3.564h-627.781l-15.895-7.049,462.027-395.76,688.43,426.224,210.451-138.663v124.669Z",
    transform: "translate(13039.028 10413.888)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-13170.283-9885.137l32.553,67.024h655.594l673.023,96.854,271.7,173.841v-137.591l-845.895-646.9-574.535,462.3-212.439-153.835v138.309Z",
    transform: "translate(13443.983 10331.907)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBg);
export default __webpack_public_path__ + "static/media/blue_bg.a32a09bef61664b4cc0218701a018f37.svg";
export { ForwardRef as ReactComponent };